import http from "../utils/http";

export function login(obj) {
  let data = obj.loginForm;
  if(obj.type!='admin'){
    data={
      mobile:obj.loginForm.userName,
      password:obj.loginForm.password
    }
  }
  return http({
    method: 'post',
    url: '/'+obj.type+'/login',
    data:data
  })
}
export function logout(type) {
  return http({
    method: 'post',
    url: '/'+type+'/logout',
  })
}
export function getUserInfo(type) {
  return http({
    method: 'get',
    url: '/'+type+'/info/find',
  })
}
export function getBaseData() {
  return http({
    method: 'get',
    url: '/common/baseData',
  })
}
export function getPostPolicy() {
  return http({
    method: 'get',
    url: '/common/file/getPostPolicy',
    params: { uploadFileType: "IMAGE" }
  })
}
// 人员管理页请求
export function getEmployeeList(current,keyword,size) {
    let params = {current,keyword,size};
    return http({
        method: 'get',
        url: '/employee/manage/paging',
        params
    })
}

// 重置密码
export function resetPwd(employeeId) {
    let params = employeeId;
    return http({
        method: 'get',
        url: '/employee/manage/resetPassword',
        params
    })
}
// 投诉反馈-学校端后台列表
export function getSchoolServerPage(params) {
  return http({
    method: 'get',
    url: 'business/bizXcwsComplaint/schoolServerPage',
    params
  })
}
// 投诉反馈-投诉记录详情
export function getSchoolInfoFind(id) {
  return http({
    method: 'get',
    url: `business/bizXcwsComplaint/${id}/find`,
  })
}
// 投诉反馈-投诉记录反馈更新
export function postFeedback(params) {
  return http({
    method: 'post',
    url: 'business/bizXcwsComplaint/feedback',
    data: params
  })
}
// 投诉反馈-投诉记录关闭恢复
export function getCloseOpen(params) {
  return http({
    method: 'get',
    url: 'business/bizXcwsComplaint/closeOpen',
    params
  })
}

//评价管理列表
export function getAssessment(params) {
  return http({
    method: 'get',
    url: '/business/xcwsEntityAssessment/paging',
    params
  })
}
//删除评论
export function delAssessment(params) {
  return http({
    method: 'post',
    url: '/business/xcwsEntityAssessment/delete',
    data:params
  })
}

//获取功能集
export function getModule() {
  return http({
    method: 'get',
    url: '/customer/moduleCollection/findCollection'
  })
}

// 获取首页配置
export function getHomeConfig(params) {
  return http({
    method: 'get',
    url: '/system/home/get',
    params
  })
}